import Alergy from "../../../../../assets/alergy.png"
import Mucus from "../../../../../assets/mucus.png"
import Revive from "../../../../../assets/revive.png"

export const BonusesData = [
    {
      id: 1,
      image: Mucus, // Replace with actual image import or path
      alt: 'Mucus',
      link: 'https://example.com/mucus', // Replace with actual URL
    },
    {
      id: 2,
      image: Alergy, // Replace with actual image import or path
      alt: 'Alergy',
      link: 'https://example.com/alergy', // Replace with actual URL
    },
    {
      id: 3,
      image: Revive, // Replace with actual image import or path
      alt: 'Revive',
      link: 'https://example.com/revive', // Replace with actual URL
    },
  ];